import type { PictureConfiguration } from "../model/picture.ts";
import type { GenericSize } from "../model/geom.ts";
import getPictureSourceImageBounds from "./get-picture-source-image-bounds.ts";

// This parallels what createBrickedSource does. However we can't directly share it
// because under the hood the resize downscaling is a very early step.
function renderSource(
	canvasCtx: CanvasDrawImage & { readonly canvas: GenericSize<number> },
	canvasSourceImage: HTMLCanvasElement | OffscreenCanvas,
	picture: Pick<
		PictureConfiguration,
		"numberOfBasePlates" | "basePlateSize" | "imageZoom" | "imageZoomOffset"
	>,
) {
	// Create a source image that constrains the image to the picture aspect ratio
	const sourceBounds = getPictureSourceImageBounds(canvasSourceImage, picture);

	// drawImage the canvasSourceImage to the canvasCtx
	canvasCtx.drawImage(
		canvasSourceImage,
		sourceBounds.x,
		sourceBounds.y,
		sourceBounds.width,
		sourceBounds.height,
		0,
		0,
		canvasCtx.canvas.width,
		canvasCtx.canvas.height,
	);
}

export default renderSource;
